import { useOrdersBrandNodes } from "../brand/nodes/orders/useOrdersBrandNodes";
import { useExclusivityBrandNodes } from "../brand/nodes/useExclusivityBrandNodes";
import { useFaireDirectBrandNodes } from "../brand/nodes/useFaireDirectBrandNodes";
import { useHowFaireWorksBrandNodes } from "../brand/nodes/useHowFaireWorksBrandNodes";
import { useIntegrationsBrandNodes } from "../brand/nodes/useIntegrationsBrandNodes";
import { useMyAccountBrandNodes } from "../brand/nodes/useMyAccountBrandNodes";
import { useMyCatalogBrandNodes } from "../brand/nodes/useMyCatalogBrandNodes";
import { useMyShopBrandNodes } from "../brand/nodes/useMyShopBrandNodes";
import { usePaymentsBrandNodes } from "../brand/nodes/usePaymentsBrandNodes";
import { useShippingBrandNodes } from "../brand/nodes/useShippingBrandNodes";
import { SelfServeNodes } from "../types";

export const useBrandNodes = (): SelfServeNodes => {
  const ORDERS_NODES = useOrdersBrandNodes();
  const SHIPPING_NODES = useShippingBrandNodes();
  const MY_ACCOUNT_NODES = useMyAccountBrandNodes();
  const PAYMENTS_NODES = usePaymentsBrandNodes();
  const MY_SHOP_NODES = useMyShopBrandNodes();
  const MY_CATALOG_NODES = useMyCatalogBrandNodes();
  const INTEGRATIONS_NODES = useIntegrationsBrandNodes();
  const FAIRE_DIRECT_NODES = useFaireDirectBrandNodes();
  const EXCLUSIVITY_NODES = useExclusivityBrandNodes();
  const HOW_FAIRE_WORKS_NODES = useHowFaireWorksBrandNodes();

  return {
    Root: {
      id: "Root",
      children: [
        "Orders",
        "Shipping",
        "MyAccount",
        "Payments",
        "MyShop",
        "MyCatalog",
        "Integrations",
        "FaireDirect",
        "Exclusivity",
        "HowFaireWorks",
      ],
      level: 0,
    },
    ...ORDERS_NODES,
    ...SHIPPING_NODES,
    ...MY_ACCOUNT_NODES,
    ...PAYMENTS_NODES,
    ...MY_SHOP_NODES,
    ...MY_CATALOG_NODES,
    ...INTEGRATIONS_NODES,
    ...FAIRE_DIRECT_NODES,
    ...EXCLUSIVITY_NODES,
    ...HOW_FAIRE_WORKS_NODES,
  };
};
